import React, { useEffect, useState } from 'react';
import { PredefinedPhrase } from '../../PredefinedPhrasesSetup/PredefinedPhrasesList';
import PredefinedPhraseSelectionItem from './../PredefinedPhraseSelectionItem/PredefinedPhraseSelectionItem';
import styles from './PredefinedPhraseSelection.module.scss';
import FlatList from '../../../../Base/Components/FlatList';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import {
	Phrase,
	PhraseType,
	useMyPhrasesQuery,
} from '../../../../../graphql/graphql';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import PredefinedPhrasesSetupModal from '../../PredefinedPhrasesSetup/PredefinedPhrasesSetupModal';
import { useFlatDataList } from '../../../../Base/Hooks/useFlatDataList';
import Loading from '../../../../../Components/Loading';

interface Props {
	onSelect: (item: PredefinedPhrase) => void;
	type: PhraseType;
}

const WRAPPER_ID = 'predefinedPhraseSelectionWrapper';

const PredefinedPhraseSelection: React.FC<Props> = ({ onSelect, type }) => {
	const [isReady, setIsReady] = useState(false);
	const [isSetupOpen, setIsSetupOpen] = useState(false);

	const { flatData, pagination, getNextPage, appendData, reset } =
		useFlatDataList<Phrase>();

	const { data, isLoading, refetch } = useMyPhrasesQuery({
		where: { type },
		pagination,
	});

	useEffect(() => {
		appendData((data?.myPhrases?.data as Phrase[]) ?? []);
	}, [data]);

	const refresh = () => {
		reset();
		refetch();
	};

	useEffect(() => {
		setIsReady(true);
	}, []);

	if (!isReady) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<LinkButton
					title='base.phrasesSetup'
					theme={Theme.BLUE}
					onClick={() => setIsSetupOpen(true)}
				/>
				{isSetupOpen && (
					<PredefinedPhrasesSetupModal
						isOpen
						onClose={() => setIsSetupOpen(false)}
						onEdit={refresh}
						type={type}
					/>
				)}
			</div>
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<FlatList
					onRefresh={refetch}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={data?.myPhrases?.meta?.hasNextPage || false}
					scrollableTargetId={WRAPPER_ID}
					itemKey={'id'}
					className={styles.list}
					renderItem={item => (
						<PredefinedPhraseSelectionItem item={item} onSelect={onSelect} />
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default PredefinedPhraseSelection;
